import { render } from "./add-schedule-modal.vue?vue&type=template&id=4bbb2bbc"
import script from "./add-schedule-modal.vue?vue&type=script&lang=js"
export * from "./add-schedule-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__